import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/core/services/user.service';
@Component({
  selector: 'app-event-header',
  templateUrl: './event-header.component.html',
  styleUrls: ['./event-header.component.scss']
})
export class EventHeaderComponent implements OnInit {
  showSubmenu: boolean = false;
  streamInfo: any = {};
  streamInfoSubscription: Subscription;
  datesList: any = [];
  isMobile: boolean = false;
  backRedirectionUrl: any;
  subEvents: any;
  subEventInfoSubscription: Subscription;
  slugInfoSubscr: Subscription;
  ticketsData: any;
  isLiveTickets: boolean = false;
  channelName: any;
  timezoneVal: any;
  clientDetails: any;
  settingsDataSubscription: Subscription;
  settingsData: any = {};

  constructor(private location: Location, private commonSubscribeService: CommanSubscribeService,
    private storageService: StorageService, public router: Router, private route: ActivatedRoute,
    private userService: UserService) { }

  ngOnInit() {
    this.clientDetails = environment.clientDetails;
    this.timezoneVal = this.userService.getTimezone();
    // this.streamInfo = this.storageService.getItem('streamInfo');
    if (Object.keys(this.route.snapshot.queryParams) && this.route.snapshot.queryParams.user_id)
      this.isMobile = true;
    else
      this.isMobile = false;
    this.backRedirectionUrl = environment.CONSUMER_PORTAL + this.route.snapshot.params.slug_name+'/cancel-payment';// environment.CONSUMER_PORTAL + 'register/' + this.route.snapshot.params.slug_name;
    this.streamInfo = this.commonSubscribeService.streamInfo;
    let slugInfo = this.commonSubscribeService.slugInfo;
    this.slugInfoSubscr = this.commonSubscribeService.getSlugData().subscribe(response => {
      slugInfo = response;
    });
    if (slugInfo) {
      this.channelName = slugInfo['channel_display_name'];
      this.ticketsData = slugInfo['tickets'];
      let liveTickets = this.ticketsData.filter(a => a.live);
      if (this.ticketsData.length == liveTickets.length) {
        this.isLiveTickets = true;
      }
    }
    this.streamInfoSubscription = this.commonSubscribeService.getStreamInfo().subscribe(response => {
      this.streamInfo = response;
      this.getDetails();
    });
    this.subEvents = this.commonSubscribeService.subEventsInfo;
    this.subEventInfoSubscription = this.commonSubscribeService.getSubEventsInfo().subscribe(response => {
      this.subEvents = response;
      this.getDetails();
    });
    if (this.streamInfo)
      this.getDetails();
    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
    })
  }
  backClicked() {
    const groupName = this.route.snapshot.params.groupName;
    const base = `${this.router.url.split("/")[1]}${groupName ? '/' + groupName : ''}`;
    let redirectTo = this.route.snapshot.params.ticket_key ? `${base}/event/home/${this.route.snapshot.params.slug_name}/${this.route.snapshot.params.ticket_key}` : `${base}/event/${this.route.snapshot.params.slug_name}`;
    if (Object.keys(this.route.snapshot.queryParams).length > 0)
      this.router.navigate([redirectTo], { queryParams: { ref: this.route.snapshot.queryParams.ref } });
    else
      this.router.navigate([redirectTo]);
    this.storageService.deleteItem('streamInfo');
    // this.location.back();
  }

  eventStartDate: any
  eventEndDate: any;
  settingsJSON: any;
  getDetails() {
    if (this.streamInfo.settings_json)
      this.settingsJSON = JSON.parse(this.streamInfo.settings_json);
    if (this.streamInfo.selected_type == "single_session_event") {
      // let localTime = moment.utc(this.streamInfo.originalPublishDate).toDate();
      // let startTime = moment(localTime).format('DD MMM YYYY');
      // let endTime = moment.utc(this.streamInfo.originalExpectedDate).toDate();
      // let eventEndTime = moment(endTime).format('DD MMM YYYY');
      let localTime = moment.utc(this.streamInfo.originalPublishDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
      let startTime = localTime.format('DD MMM YYYY');
      let endTime = moment.utc(this.streamInfo.originalExpectedDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
      let eventEndTime = endTime.format('DD MMM YYYY');
      if (moment(eventEndTime).isAfter(startTime)) {
        this.streamInfo.eventStart = localTime.format('DD MMM YYYY, hh:mm A');
        this.streamInfo.eventEnd = endTime.format('DD MMM YYYY, hh:mm A');
        // this.streamInfo.eventStart = moment(localTime).format('DD MMM YYYY, hh:mm A');
        // this.streamInfo.eventEnd = moment(endTime).format('DD MMM YYYY, hh:mm A');
      } else {
        this.streamInfo.eventStart = localTime.format('DD MMM YYYY, hh:mm A');
        this.streamInfo.eventEnd = endTime.format('hh:mm A');
        // this.streamInfo.eventStart = moment(localTime).format('DD MMM YYYY, hh:mm A');
        // this.streamInfo.eventEnd = moment(endTime).format('hh:mm A');
      }
    }
    // originalPublishDate/originalExpectedDate (and publish_date_time/expected_end_date_time,
    // still raw at this point) are bare UTC "YYYY-MM-DD HH:mm:ss" - parse via
    // moment.utc(...).tz(...) like the rest of this file instead of formatting the raw value,
    // which showed the wrong calendar date to viewers on the other side of UTC.
    let publishLocalForBanner = moment.utc(this.streamInfo.originalPublishDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
    let expectedEndLocalForBanner = moment.utc(this.streamInfo.originalExpectedDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
    this.streamInfo.publish_date_time = publishLocalForBanner.format("ddd") + ", " + publishLocalForBanner.format("DD MMM") + " " + publishLocalForBanner.format("YYYY");
    this.streamInfo.expected_end_date_time = expectedEndLocalForBanner.format("ddd") + ", " + expectedEndLocalForBanner.format("DD MMM") + " " + expectedEndLocalForBanner.format("YYYY");
    if (this.streamInfo.event_dates_json) {
      this.streamInfo.event_dates_json = typeof this.streamInfo.event_dates_json == 'string' ? JSON.parse(this.streamInfo.event_dates_json) : this.streamInfo.event_dates_json;
      let datesArr = [];
      if (this.subEvents && this.subEvents.length > 0) {
        this.subEvents.forEach(event => {
          // let eventDate = moment.utc(event.stream_info.publish_date_time).toDate();
          // event.start = moment(eventDate).format('YYYY-MM-DD');
          // let eventEnd = moment.utc(event.stream_info.expected_end_date_time).toDate();
          // event.end = moment(eventEnd).format('YYYY-MM-DD');
          let localTime = moment.utc(event.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
          event.start = localTime.format('YYYY-MM-DD');
          let eventEnd = moment.utc(event.stream_info.expected_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
          event.end = eventEnd.format('YYYY-MM-DD');
          datesArr.push(event);
        });
      }
      this.datesList = [...new Map(datesArr.map(item =>
        [item['start'], item])).values()];
      this.datesList = this.datesList.sort((a, b) => a.start > b.start ? 1 : -1);
      // this.datesList = [...this.streamInfo.event_dates_json];
      if (this.datesList && this.datesList.length > 0) {
        this.datesList.forEach((date, key) => {
          date.originalDate = date.start;
          date.start = moment(date.start).format("DD MMM") + " " + moment(date.start).format("YYYY");
          if (this.streamInfo.selected_type == 'single_day_event' || this.streamInfo.selected_type == 'multi_day_event') {
            if (key == 0)
              this.eventStartDate = moment(date.originalDate).format("DD MMM") + " " + moment(date.originalDate).format("YYYY");
            this.eventEndDate = moment(date.end).format("DD MMM") + " " + moment(date.end).format("YYYY");
          }
        });
      }
    }
  }

  ngOnDestroy() {
    if (this.streamInfoSubscription) {
      this.streamInfoSubscription.unsubscribe();
    }
    if (this.subEventInfoSubscription) {
      this.subEventInfoSubscription.unsubscribe();
    }
    if (this.slugInfoSubscr) {
      this.slugInfoSubscr.unsubscribe();
    }
  }
}
